import React from 'react';
import { renderFeatureBadge } from 'js/constants/featureBadges';
import ExternalTriggerConfig from 'js/components/elements/ExternalTriggerConfig/ExternalTriggerConfig';
import { InfoModal } from './InfoModal';
import { useExternalTrigger } from './context/ExternalTriggerContext';

export const ExternalTriggerUsage = () => {
  const { isOpen, data, closePortal } = useExternalTrigger();
  if (!data) return null;

  return (
    <InfoModal
      isOpen={isOpen}
      onClose={closePortal}
      title="External Trigger Configuration"
      description="Use the configuration below to trigger a flow from an external source. The flow will be triggered when the endpoint is called."
      featureBadge={renderFeatureBadge('EXTERNAL_TRIGGER', {
        variant: 'text',
        sx: {
          marginLeft: '4px',
          fontSize: '0.85em',
          opacity: 0.8,
          position: 'relative',
          top: -4,
        },
      })}
    >
      <ExternalTriggerConfig data={data} />
    </InfoModal>
  );
};
